<div class="game-debug" style="width: 100%; height: 100%; background: white">
  <h2 style="font-weight: bold">Map</h2>
  <app-debug-instance [instance]="_gameService.map()" />
  <h2 style="font-weight: bold">Mission</h2>
  <app-debug-instance [instance]="_gameService.mission()" />
  <h2 style="font-weight: bold">Activity</h2>
  <app-debug-instance [instance]="_gameService.activity()" />
  <h2 style="font-weight: bold">Story</h2>
  <app-debug-instance [instance]="_gameService.story()" />

  <br />

  <h2 style="font-weight: bold">Queued Missions</h2>
  @for (queuedMission of _lpMissionService.missionQueue(); track $index) {
    <app-debug-instance [instance]="queuedMission" />
  }
  <h2 style="font-weight: bold">Finished Missions</h2>
  @for (finishedMission of _lpMissionService.finishedMissions(); track $index) {
    <app-debug-instance [instance]="finishedMission" />
  }

  <br />

  <h2 style="font-weight: bold">Variables</h2>
  <app-debug-variables [entries]="_lpVariablesService.stateList()" style="display: block" />
</div>
